export default "__VITE_ASSET__Sze79F1d__";